export enum BorrowStep {
    Collateral = "Collateral",
    Principal = "Amount"
}
export const BORROW_STEPS = [BorrowStep.Collateral, BorrowStep.Principal];
